"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Unwrap from blockquote.
 */
function unwrapBlockquote(opts, editor) {
    return editor.unwrapBlock(opts.type);
}
exports.default = unwrapBlockquote;
//# sourceMappingURL=unwrapBlockquote.js.map